/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * LegalForm:   * `31` - Aktiengesellschaft   * `25` - Aktiengesellschaft u. Co. KG   * `26` - Aktiengesellschaft u. Co. OHG   * `49` - Andere Erwerbs- oder Wirtschaftsgenossenschaft   * `20` - Atypische stille Gesellschaft   * `91` - Ausländische Körperschaft   * `92` - Ausländische Personengesellschaft   * `34` - Bergrechtliche Gewerkschaft   * `30` - Eingetragene Genossenschaft (eG)   * `52` - Eingetragener Verein   * `36` - Europäische Aktiengesellschaft   * `28` - Europäische wirtschaftliche Interessenvereinigung   * `81` - Gebietskörperschaft   * `38` - Gemeinnützige Gesellschaft mit beschränkter Haftung (gGmbH)   * `27` - Gesellschaft des bürgerlichen Rechts   * `35` - Gesellschaft mit beschränkter Haftung   * `23` - GmbH u. Co. KG   * `24` - GmbH u. Co. OHG   * `33` - Kolonialgesellschaft   * `22` - Kommanditgesellschaft   * `32` - Kommanditgesellschaft auf Aktien   * `41` - Kreditgenossenschaft, die Kredite ausschließlich an ihre Mitglieder gewährt   * `43` - Landwirtschaftl. Nutzungs- oder Verwaltungsgenossenschaft   * `61` - Nichtrechtsfähiger Verein, Anstalt, Stiftung oder anderes Zweckvermögen   * `21` - Offene Handelsgesellschaft   * `82` - Öffentl.-rechtl. Religionsgesellschaft   * `74` - Öffentl.-rechtl. Versorgungs-, Verkehrs- oder Hafenbetrieb   * `72` - Öffentliche oder unter Staatsaufsicht stehende Sparkasse   * `16` - Person mit Beteiligungen an gewerbl. Personengesellschaften   * `44` - Realgemeinde   * `45` - SCE Europäische Genossenschaft   * `99` - Sonstige ausländische Rechtsform   * `59` - Sonstige juristische Person des privaten Rechts   * `83` - Sonstige juristische Personen des öffentlichen Rechts   * `39` - Sonstige Kapitalgesellschaft   * `73` - Sonstige Kreditanstalt des öffentlichen Rechts   * `29` - Sonstige Personengesellschaft (z.B. Grundstücksgemeinschaft o.Ä.)   * `79` - Sonstiger Betrieb gewerblicher Art von jur. Personen des öffentlichen Rechts   * `71` - Staatsbank   * `40` - Stiftung &amp; Co. KG   * `37` - Unternehmergesellschaft (haftungsbeschränkt)   * `51` - Versicherungsverein auf Gegenseitigkeit   * `42` - Zentralkasse, die Kredite ausschließlich an ihre Mitglieder gewährt und sich auf genossenschaftl. Aufgaben beschränkt  *Legal form cannot be used together with Natural person.* 
 */
export enum LegalFormEnumDTO {
    LF_31 = '31',
    LF_25 = '25',
    LF_26 = '26',
    LF_49 = '49',
    LF_20 = '20',
    LF_91 = '91',
    LF_92 = '92',
    LF_34 = '34',
    LF_30 = '30',
    LF_52 = '52',
    LF_36 = '36',
    LF_28 = '28',
    LF_81 = '81',
    LF_38 = '38',
    LF_27 = '27',
    LF_35 = '35',
    LF_23 = '23',
    LF_24 = '24',
    LF_33 = '33',
    LF_22 = '22',
    LF_32 = '32',
    LF_41 = '41',
    LF_43 = '43',
    LF_61 = '61',
    LF_21 = '21',
    LF_82 = '82',
    LF_74 = '74',
    LF_72 = '72',
    LF_16 = '16',
    LF_44 = '44',
    LF_45 = '45',
    LF_99 = '99',
    LF_59 = '59',
    LF_83 = '83',
    LF_39 = '39',
    LF_73 = '73',
    LF_29 = '29',
    LF_79 = '79',
    LF_71 = '71',
    LF_40 = '40',
    LF_37 = '37',
    LF_51 = '51',
    LF_42 = '42'
}

export class ClsLegalFormEnumDTO {
    LF_31 = '31';
    LF_25 = '25';
    LF_26 = '26';
    LF_49 = '49';
    LF_20 = '20';
    LF_91 = '91';
    LF_92 = '92';
    LF_34 = '34';
    LF_30 = '30';
    LF_52 = '52';
    LF_36 = '36';
    LF_28 = '28';
    LF_81 = '81';
    LF_38 = '38';
    LF_27 = '27';
    LF_35 = '35';
    LF_23 = '23';
    LF_24 = '24';
    LF_33 = '33';
    LF_22 = '22';
    LF_32 = '32';
    LF_41 = '41';
    LF_43 = '43';
    LF_61 = '61';
    LF_21 = '21';
    LF_82 = '82';
    LF_74 = '74';
    LF_72 = '72';
    LF_16 = '16';
    LF_44 = '44';
    LF_45 = '45';
    LF_99 = '99';
    LF_59 = '59';
    LF_83 = '83';
    LF_39 = '39';
    LF_73 = '73';
    LF_29 = '29';
    LF_79 = '79';
    LF_71 = '71';
    LF_40 = '40';
    LF_37 = '37';
    LF_51 = '51';
    LF_42 = '42';
}

